import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-expandable-item',
  templateUrl: './expandable-item.component.html',
  styleUrls: ['./expandable-item.component.scss'],
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableItemComponent {
  protected expanded = signal(false);
}
